import { useState } from 'react';
import { useForm, useFormState } from 'react-hook-form';
import Select from 'react-select';

import { Message } from '@components';
import {
  EmailField,
  FormFieldset,
  MultiSelectField,
  TextField,
} from '@Forms/fields.jsx';
import { errorsFromMutate } from '@Forms/utils.js';
import { ButtonSpinnerDarkIcon } from '@svgs';

export const AccessForm = ({
  businessAccessData,
  disablingInProgress,
  locationAccessData,
  mutations,
  siteAccessData,
  templateSiteAccessData,
  templateSiteID,
  usersData,
}) => {
  const [selectedOption, setSelectedOption] = useState('');

  // is the optional template site access granted alongside the site access
  //
  // requires the whitelabel `TemplateSite` group and a template site on the
  // theme, both of which are resolved into `templateSiteID` by the parent
  const templateSiteAccessEnabled =
    !!templateSiteID && !!templateSiteAccessData;

  const onChange = async (val) => {
    // new lists by appending the User ID
    //
    // grant access to the Business, Location and Site
    setSelectedOption('');

    if (!businessAccessData.find((u) => u.id == val.value)) {
      // if not already granted access, then grant access to location
      let newBusinessList = [...businessAccessData, { id: val.value }];
      mutations.business.mutateAsync(newBusinessList);
    }

    if (!locationAccessData.find((u) => u.id == val.value)) {
      // if not already granted access, then grant access to location
      let newLocationList = [...locationAccessData, { id: val.value }];
      mutations.location.mutateAsync(newLocationList);
    }

    if (
      templateSiteAccessEnabled &&
      !templateSiteAccessData.find((u) => u.id == val.value)
    ) {
      // if not already granted access, then grant access to the template site
      let newTemplateSiteList = [...templateSiteAccessData, { id: val.value }];
      mutations.templateSite.mutateAsync(newTemplateSiteList);
    }

    // give site access
    const newSiteList = [...siteAccessData, { id: val.value }];
    mutations.site.mutateAsync(newSiteList);
  };

  // combined isPending status check
  const isPending =
    mutations.site.isPending ||
    mutations.location.isPending ||
    mutations.business.isPending ||
    (templateSiteAccessEnabled && mutations.templateSite.isPending);

  // list of options to pass to react-select
  // filter to exclude users already granted access
  let userOptions = usersData
    ? usersData.objects
        .filter((user) => !siteAccessData.find((u) => u.id == user.id))
        .map((user) => {
          return {
            value: user.id,
            label: `${user.first_name} ${user.last_name} <${user.email}>`,
          };
        })
    : [];

  return (
    <form
      className={
        `sb-manage-content-form ` +
        (disablingInProgress || isPending ? 'sb-form-disabled' : '')
      }
    >
      <FormFieldset legend="Grant access">
        <div className={`sb-form-item-formgroup sb-form-item-multiselect`}>
          <label htmlFor="user_id">Select user</label>
          <div className="sb-form-item-content">
            {isPending && <ButtonSpinnerDarkIcon />}
            {!isPending && (
              <Select
                name={'user_id'}
                isDisabled={disablingInProgress}
                className="basic-multi-select"
                classNamePrefix="select"
                options={userOptions}
                value={selectedOption}
                onChange={onChange}
              />
            )}
          </div>
        </div>
      </FormFieldset>
      <div className="sb-manage-content-button-bar">
        {(mutations.site.isError ||
          (templateSiteAccessEnabled && mutations.templateSite.isError)) && (
          <Message messageStyle="error" title="Error enabling access" />
        )}
        {mutations.site.isSuccess && (
          <Message messageStyle="success" title="Successfully added access" />
        )}
      </div>
    </form>
  );
};

export default AccessForm;
